var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card p-3" }, [
    _vm._v(
      "\n    Este pedido possui desconto de " +
        _vm._s(parseInt(_vm.faixa.valor)) +
        "%\n    "
    ),
    _c("div", { staticClass: "progress" }, [
      _c("div", {
        staticClass: "progress-bar progress-bar-striped bg-primary",
        style: _vm.showPercent,
        attrs: {
          role: "progressbar",
          "aria-valuenow": _vm.valor,
          "aria-valuemin": _vm.faixa.quantidade_minima,
          "aria-valuemax": _vm.faixa.quantidade_maxima
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3a1fba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3a1fba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/propostas/card-desconto.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4e3a1fba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/propostas/card-desconto.vue
// module chunks = 2